// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAccumulatorModel {
    static getAttributeTypeMap() {
        return ClaimAccumulatorModel.attributeTypeMap;
    }
}
ClaimAccumulatorModel.discriminator = undefined;
ClaimAccumulatorModel.additionalProperties = false;
ClaimAccumulatorModel.attributeTypeMap = [
    {
        "name": "accumulatorId",
        "baseName": "accumulatorId",
        "type": "number"
    },
    {
        "name": "accumulatorTypeId",
        "baseName": "accumulatorTypeId",
        "type": "number"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<string>"
    },
    {
        "name": "balance",
        "baseName": "balance",
        "type": "number"
    },
    {
        "name": "availableBalance",
        "baseName": "availableBalance",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
];
//# sourceMappingURL=claimAccumulatorModel.js.map